<template>
    <site-img
        v-if="partners && partners.length"
        class="md-partner standard"
        type="bgImg"
        :src="bgType === 'img' ? useBgSrc : ''"
        :style="containerStyle"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
            @mouseenter.native="playSlider(false)"
            @mouseleave.native="playSlider(true)"
        >
            <div class="mg-title" v-if="title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div
                class="partner-container"
                v-if="partners && partners.length > 0"
                ref="swiperContainer"
            >
                <ul ref="swiper" class="slider-container">
                    <li
                        v-for="(partner, index) in clonePartner"
                        :key="index"
                        class="partner-item"
                    >
                        <partner-logo
                            @load="calcMoveWidth"
                            :partner="partner"
                        ></partner-logo>
                    </li>
                </ul>
            </div>
        </module-box>
    </site-img>
</template>

<script>
import common, { swiperMixin } from '../index';

export default {
    mixins: [common, swiperMixin],
    data: function() {
        return {
            swiperMargin: {
                pc: 40,
                mobile: 20
            }
        };
    },
    mounted() {
        this.initSwiper();
        this.resizeListener();
    }
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-partner.standard {
    .partner-container {
        display: flex;
        justify-content: space-between;
        .slider-container {
            display: flex;
            overflow: hidden;
            justify-content: center;
            width: 100%;
            .partner-item {
                flex: 1;
                margin-right: 40px;
                //  Avoid line height caused by anonymous spaces
                line-height: 0;
                display: flex;
                justify-content: center;
                @include media-600 {
                    margin-right: 20px;
                }
            }
        }
        .iconfont {
            font-size: 40px;
            line-height: 48px;
            opacity: 0.6;
            color: #c6c8d1;
        }
    }

    @include media-600 {
        .partner-container {
            .slider-container {
                overflow-x: scroll;
                &::-webkit-scrollbar {
                    display: none;
                }
                .partner-item {
                    margin: 0 20px 0 0;
                }
            }

            .iconfont {
                display: none;
            }
        }
    }
}
</style>
